import { GET_USERS } from 'apis/GraphQL/Variables/user';
import {
  IAddCustomerInTeamRoute,
  ICheckValidSaleTeam,
  IFilterTeamSale,
  IFilterTeamSaleCb,
  IGetAllById,
  IGetAllComboBox,
  IGetAllFilterTeamSales,
  IGetManagerCombobox,
  IGetSlocByPlant,
  IGetTeamSaleDetailById,
  IGetUserByPlantNotTeamSale,
  IGetUserSaleInCombobox,
  IGetValidTeamSaleById,
  IParamsCreate,
  IParamsUpdate,
} from 'interfaces/TeamSale/TeamSale';
import {
  ADD_CUSTOMER_IN_TEAM_ROLE,
  CHECK_EXIST_ROUTE_OF_SALE_TEAM,
  CHECK_USER_ACTIVE_ROUTE_IN_TEAM,
  CHECK_VALID_SALE_TEAM_BY_ID,
  GENERATE_TEAM_CODE,
  GET_ALL_FITLER_TEAM_SALES,
  Get_Customer_By_Team_Sale_Route,
  GET_MANAGER_COMBOBOX,
  GET_PROGRESS_BY_PLANT_ID,
  GET_SLOC_BY_PLANT_ID,
  GET_TEAM_SALES,
  GET_TEAM_SALES_COMBOBOX,
  GET_TEAM_SALES_COMBOBOX_SUB_SORT,
  GET_USER_BY_PLANT_ID,
  GET_VALID_TEAM_SALE_BY_ID,
  Q_CREATE_TEAMSALE,
  Q_DELETE_TEAM_SALE_CUST,
  Q_DELETE_TEAMSALE,
  Q_GET_CUSTOMER_BY_TS,
  Q_GET_EMPLOYEES_NO_TS,
  Q_GET_TS_BY_ID,
  Q_UPDATE_TEAMSALE,
} from './GraphQL/Queries/teamSaleQuery';
import { TEAMSALE_VARIABLE } from './GraphQL/Variables/teamSale';
import axiosGraphQL from './GraphQL/axiosGraphQL';

export const SaleTeamApi = {
  deleteTeamSaleCustomer: async (customerId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: Q_DELETE_TEAM_SALE_CUST,
      variables: TEAMSALE_VARIABLE.deleteCustomer(customerId),
    });
  },
  getAll: async (params: IFilterTeamSale) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_TEAM_SALES,
      variables: TEAMSALE_VARIABLE.getAll(params),
    });
  },
  getAllFilterTeamSales: async (params: IGetAllFilterTeamSales) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_ALL_FITLER_TEAM_SALES,
      variables: TEAMSALE_VARIABLE.getAllFilterTeamSales(params),
    });
  },
  getAllTeamSaleCb: async (params: IFilterTeamSaleCb) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_TEAM_SALES_COMBOBOX,
      variables: TEAMSALE_VARIABLE.getAllTeamSaleCb(params),
    });
  },
  getAllTeamSaleCbSubSort: async (params: IFilterTeamSaleCb) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_TEAM_SALES_COMBOBOX_SUB_SORT,
      variables: TEAMSALE_VARIABLE.getAllTeamSaleCb(params),
    });
  },
  GetCustomerByTeamSaleRoute: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: Get_Customer_By_Team_Sale_Route,
      variables: TEAMSALE_VARIABLE.GetCustomerByTeamSaleRoute(params),
    });
  },
  getAllComboBox: async (params: IGetAllComboBox) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_TEAM_SALES_COMBOBOX,
      variables: TEAMSALE_VARIABLE.getAllComboBox(params),
    });
  },
  searchCustomer: async (params: IGetAllById) => {
    return await axiosGraphQL.post('/graphql', {
      query: Q_GET_CUSTOMER_BY_TS,
      variables: TEAMSALE_VARIABLE.getCustomerByTS(params),
    });
  },
  getAllEmployeeById: async (params: IGetTeamSaleDetailById) => {
    return await axiosGraphQL.post('/graphql', {
      query: Q_GET_TS_BY_ID,
      variables: TEAMSALE_VARIABLE.getTeamSaleDetailById(params),
    });
  },
  addCustomerInTeamRoute: async (params: IAddCustomerInTeamRoute) => {
    return await axiosGraphQL.post('/graphql', {
      query: ADD_CUSTOMER_IN_TEAM_ROLE,
      variables: TEAMSALE_VARIABLE.addCustomerInTeamRoute(params),
    });
  },
  getUserNotTeamSale: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: Q_GET_EMPLOYEES_NO_TS,
      variables: TEAMSALE_VARIABLE.getEmployeeNoTS(),
    });
  },
  createTeamSale: async (params: IParamsCreate) => {
    return await axiosGraphQL.post('/graphql', {
      query: Q_CREATE_TEAMSALE,
      variables: TEAMSALE_VARIABLE.create(params),
    });
  },
  deleteSaleTeam: async (teamSaleId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: Q_DELETE_TEAMSALE,
      variables: TEAMSALE_VARIABLE.deleteSaleTeam(teamSaleId),
    });
  },
  updateSaleTeam: async (params: IParamsUpdate) => {
    return await axiosGraphQL.post('/graphql', {
      query: Q_UPDATE_TEAMSALE,
      variables: TEAMSALE_VARIABLE.update(params),
    });
  },
  generateTeamCodeByTypeAndPlantId: async (params: {
    type: string;
    plantId: string;
  }) => {
    return await axiosGraphQL.post('/graphql', {
      query: GENERATE_TEAM_CODE,
      variables: TEAMSALE_VARIABLE.generateTeamCodeByTypeAndPlantId(params),
    });
  },
  getUserByPlantId: async (params: IGetUserByPlantNotTeamSale) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_USER_BY_PLANT_ID,
      variables: TEAMSALE_VARIABLE.getUserByPlantId(params),
    });
  },
  getSlocByPlantId: async (params: IGetSlocByPlant) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_SLOC_BY_PLANT_ID,
      variables: TEAMSALE_VARIABLE.getSlocByPlantId(params),
    });
  },
  getUserRoleSaleInCBB: async (params: IGetUserSaleInCombobox) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_USER_BY_PLANT_ID,
      variables: GET_USERS.getUserRoleSaleInCBB(params),
    });
  },
  getProgressByPlantId: async (params: {
    plantId: string;
    teamId?: string;
  }) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_PROGRESS_BY_PLANT_ID,
      variables: TEAMSALE_VARIABLE.getProgressByPlantId(params),
    });
  },
  checkExistRouteOfSaleTeam: async (teamSaleId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: CHECK_EXIST_ROUTE_OF_SALE_TEAM,
      variables: TEAMSALE_VARIABLE.checkExistRouteOfSaleTeam(teamSaleId),
    });
  },
  checkValidSaleTeamById: async (params: ICheckValidSaleTeam) => {
    return await axiosGraphQL.post('/graphql', {
      query: CHECK_VALID_SALE_TEAM_BY_ID,
      variables: TEAMSALE_VARIABLE.checkValidTeamSale(params),
    });
  },
  getValidTeamSaleById: async (params: IGetValidTeamSaleById) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_VALID_TEAM_SALE_BY_ID,
      variables: TEAMSALE_VARIABLE.getValidTeamSaleById(params),
    });
  },
  checkUserActiveRouteInTeam: async (params: {
    teamSalesSubId: string;
    plantId: string;
  }) => {
    return await axiosGraphQL.post('/graphql', {
      query: CHECK_USER_ACTIVE_ROUTE_IN_TEAM,
      variables: TEAMSALE_VARIABLE.checkUserActiveRouteInTeam(params),
    });
  },
  getManagersCombobox: async (params: IGetManagerCombobox) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_MANAGER_COMBOBOX,
      variables: TEAMSALE_VARIABLE.getManagersCombobox(params),
    });
  },
};
